import React from 'react';
import './style.scss';

const LoadingIndicator = () => (
  <div className="modernLoader">
    <span className="modernLoaderBar" />
    <span className="modernLoaderBar" />
    <span className="modernLoaderBar" />
    <span className="modernLoaderBar" />
  </div>
);

export default LoadingIndicator;
